import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@component/dialog";
import { Button } from "@component/button";
import { AlertTriangleIcon } from "lucide-react";

interface ExternalShareWarningDialogProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
}

export default function ExternalShareWarningDialog({
    isOpen,
    onClose,
    onConfirm,
}: ExternalShareWarningDialogProps) {
    return (
        <Dialog open={isOpen} onOpenChange={onClose}>
            <DialogContent className="sm:max-w-[500px]">
                <DialogHeader>
                    <div className="flex items-center gap-3 mb-2">
                        <div className="w-10 h-10 rounded-full bg-amber-100 flex items-center justify-center flex-shrink-0">
                            <AlertTriangleIcon className="h-5 w-5 text-amber-600" />
                        </div>
                        <DialogTitle className="text-xl">Invite to Collaborate?</DialogTitle>
                    </div>
                    <DialogDescription
                        className="text-base text-foreground pt-2"
                        style={{ paddingBottom: "8px" }}
                    >
                        It looks like you are inviting users who are not part of your
                        workspace.
                        <br />
                        <br />
                        By inviting them to collaborate, they will be allowed to view and
                        shortlist applicants for this job listing.
                    </DialogDescription>
                </DialogHeader>
                <DialogFooter className="flex-row gap-2 sm:gap-2">
                    <Button
                        variant="outline"
                        onClick={onClose}
                        className="flex-1 sm:flex-1"
                    >
                        Cancel
                    </Button>
                    <Button
                        onClick={onConfirm}
                        className="flex-1 sm:flex-1"
                        style={{ backgroundColor: "#2563eb" }}
                    >
                        Send Invite
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
